import { useAppStore } from "@/stores";

/** The signed-in player's hash — what a shared payload's `player` fields are compared with to
 *  mark the reader's own row ("You"). Same source the tournament leaderboard reads. */
export const useViewerHash = (): string | null =>
  useAppStore(
    (state) =>
      state.playerHash ?? (state.authData?.player_hash as string) ?? null
  );
